import React from 'react';
import {
    Card, CardHeader, CardBody,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter, CardFooter,
    Button
} from 'reactstrap';

export default class CardExperiencia extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.download = this.download.bind(this);
    }

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    download = (e) =>{
        e.preventDefault();
        let name = e.target.parentNode.dataset.name;
        let url = e.target.parentNode.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    };

    render() {
        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.institucion}</b>
                            <br />
                            <br />
                            <span className="spanCard">CARGO: </span>{this.props.cargo}
                            <br />
                            <span className="spanCard">TIPO INSTITUCIÓN: </span>{this.props.strNombreTipoInstitucion}
                            <br />
                            <span className="spanCard">TIPO DE RELACIÓN LABORAL: </span>{this.props.strNombreTipoRelacionLaboral}
                            <br />
                            <span className="spanCard">DESDE: </span> {this.parseDate(this.props.fechadesde)}
                            <br />
                            <span className="spanCard">HASTA: </span> {this.parseDate(this.props.fechahasta)}
                            <br />
                            <span className="spanCard">PAÍS: </span>{this.props.strNombrePais}
                            <br />
                            {
                                this.props.tiempodedicacion !== "NN"?
                                <>
                                        <span className="spanCard">TIEMPO DE DEDICACIÓN: </span>{this.props.strNombreTipoDedicacion}
                                        <br />
                                </>
                                :
                                null
                            }

                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            {this.props.evidencias.map((evidencia) =>
                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                            )}
                            {this.props.evidencias2.map((evidencia) =>
                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                            )}
                            {this.props.tipo ?
                                (<CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>)
                                : ('')}

                            
                            {this.props.tipo ?
                                (<CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>)
                                : ('') }
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}